define(["require", "exports", "tslib", "mobx", "moment", "../../utils/EntityUtil", "../../utils/Environment", "../../utils/StringUtil"], function (require, exports, tslib_1, mobx_1, moment_1, EntityUtil_1, Environment_1, StringUtil_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ImageSearchField = exports.SearchField = exports.SearchParameterListItem = exports.applyCase = exports.SearchParameter = exports.SearchLayer = exports.SearchConfig = void 0;
    moment_1 = tslib_1.__importDefault(moment_1);
    class SearchConfig {
        constructor(searchConfig) {
            Object.defineProperty(this, "layers", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: []
            });
            for (const l of searchConfig.layers) {
                const layer = new SearchLayer(l);
                if (layer.rank === -1) {
                    layer.rank = this.layers.length;
                }
                if (layer.enabled || !(0, Environment_1.isProduction)()) {
                    this.layers.push(layer);
                }
            }
        }
        getLayer(id) {
            if (this.layers.length > 0) {
                let layerIndex = 0;
                if (id) {
                    layerIndex = this.layers.findIndex((l) => l.id && l.id === id);
                }
                return this.layers[layerIndex === -1 ? 0 : layerIndex];
            }
            return null;
        }
    }
    exports.SearchConfig = SearchConfig;
    class SearchLayer {
        constructor(layer) {
            Object.defineProperty(this, "id", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "name", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "url", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "route", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "params", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "fields", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "titleField", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "linkField", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "linkAlias", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "colour", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "rank", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "precision", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "enabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "searchable", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.id = layer.id || (0, EntityUtil_1.id)();
            this.name = layer.name;
            this.url = layer.url;
            this.route = layer.route;
            this.params = layer.params.map(x => new SearchParameter(x));
            this.fields = layer.fields.map(x => SearchField.parse(x));
            this.titleField = layer.titleField;
            this.linkField = layer.linkField;
            this.linkAlias = layer.linkAlias;
            this.searchable = layer.searchable === undefined ? true : !!layer.searchable;
            this.enabled = layer.enabled === undefined ? true : !!layer.enabled;
            this.colour = layer.colour || "inherit";
            this.rank = layer.rank || -1;
            this.precision = layer.precision || -1;
        }
        get IsValid() {
            return this.params.every((p) => p.IsValid);
        }
        toExpressionQuery() {
            return this.params.filter(x => x.HasValue).map(x => x.toExpressionQuery()).join(" AND ");
        }
        reset() {
            this.params.forEach((p) => p.reset());
        }
    }
    exports.SearchLayer = SearchLayer;
    class SearchParameter {
        constructor(param) {
            var _a;
            Object.defineProperty(this, "id", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "visible", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "label", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "type", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "subType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "labelField", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "maxResults", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "minChars", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "query", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "queryCaseFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "resultCaseFilter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "validationRegex", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "defaultValue", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "optional", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "tooltip", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "list", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Empty", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ""
            });
            Object.defineProperty(this, "serverTzUtcOffset", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "value", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: this.Empty
            });
            Object.defineProperty(this, "valueError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ""
            });
            (0, mobx_1.makeObservable)(this, {
                value: mobx_1.observable,
                valueError: mobx_1.observable,
                reset: mobx_1.action
            });
            this.id = param.id || (0, EntityUtil_1.id)();
            this.visible = (_a = param.visible) !== null && _a !== void 0 ? _a : true;
            this.label = param.label;
            this.type = param.type;
            this.subType = param.subType;
            this.serverTzUtcOffset = param.serverTzUtcOffset;
            this.labelField = param.labelField;
            this.maxResults = param.maxResults;
            this.minChars = param.minChars;
            this.query = param.query;
            this.queryCaseFilter = param.queryCaseFilter;
            this.resultCaseFilter = param.resultCaseFilter;
            this.validationRegex = param.validationRegex;
            this.defaultValue = param.defaultValue;
            this.optional = param.optional;
            this.tooltip = param.tooltip;
            this.optional = param.optional;
            this.list = param.list ? param.list.map(x => new SearchParameterListItem(x)) : undefined;
            this.value = this.defaultValue ? this.defaultValue : undefined;
            (0, mobx_1.autorun)(() => {
                if (this.value) {
                    console.log(`${this.label} value:`, this.value);
                }
            });
        }
        get IsValid() {
            if (this.optional && !this.HasValue) {
                return true;
            }
            else if (!this.optional && !this.HasValue) {
                return false;
            }
            else if (this.validationRegex) {
                return new RegExp(this.validationRegex).test(this.value.toString());
            }
            else {
                return true;
            }
        }
        get HasValue() {
            return !!this.value && this.value.toString().trim().length > 0;
        }
        toExpressionQuery() {
            switch (this.type) {
                case "date":
                    return this.query.replace(/\{\?\}/g, this.getUtcDateString(this.value));
                default:
                    let searchValue = applyCase(this.value.trim(), this.queryCaseFilter);
                    return this.query.replace(/\{\?\}/g, searchValue.replace(/'/g, "''"));
            }
        }
        reset() {
            this.value = this.defaultValue ? this.defaultValue : this.Empty;
        }
        getUtcDateString(value) {
            const utcDate = (0, moment_1.default)(value).utc();
            let serverLocalTzDate = utcDate.add(this.serverTzUtcOffset, "hours");
            if (this.subType) {
                if (this.subType.toLowerCase() === "fromdate") {
                    return `date '${serverLocalTzDate.format("YYYY-MM-DD")}'`;
                }
                else if (this.subType.toLowerCase() === "todate") {
                    serverLocalTzDate = utcDate.add(1, "day");
                    return `date '${serverLocalTzDate.format("YYYY-MM-DD")}'`;
                }
            }
            return `date '${serverLocalTzDate.format("YYYY-MM-DD")}'`;
        }
    }
    exports.SearchParameter = SearchParameter;
    function applyCase(value = "", caseFilter) {
        switch (caseFilter) {
            case "uppercase":
                return value.toUpperCase();
            case "lowercase":
                return value.toLowerCase();
            case "titlecase":
                return StringUtil_1.StringUtil.toTitleCase(value);
            default:
                return value;
        }
    }
    exports.applyCase = applyCase;
    class SearchParameterListItem {
        constructor(config) {
            Object.defineProperty(this, "k", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "v", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.k = config.k;
            this.v = config.v;
        }
    }
    exports.SearchParameterListItem = SearchParameterListItem;
    class SearchField {
        static parse(config) {
            if (config.type && config.type.toString().toLowerCase() === "image") {
                return new ImageSearchField(config);
            }
            else {
                return new SearchField(config);
            }
        }
        constructor(config) {
            Object.defineProperty(this, "name", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "type", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "alias", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "visible", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "dateFormat", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.name = config.name;
            this.alias = config.alias;
            this.visible = config.visible === true;
            this.dateFormat = config.dateFormat;
        }
    }
    exports.SearchField = SearchField;
    class ImageSearchField extends SearchField {
        constructor(config) {
            super(config);
            Object.defineProperty(this, "service", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "method", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "imageIdParam", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "idField", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            this.service = config.service;
            this.method = config.method;
            this.idField = config.idField;
            this.imageIdParam = config.imageIdParam;
        }
    }
    exports.ImageSearchField = ImageSearchField;
});
